/**
 * Composant de bouton de catégorie pour l'interface du quiz
 * Affiche les statistiques d'une catégorie (Histoire par défaut)
 */
import "../styles/setting.css";
import "../styles/bouton_quest.css";

/**
 * BoutonCat - Composant d'affichage de catégorie de quiz
 * @param {Object} props - Les propriétés du composant
 * @param {string} props.className - Classes CSS additionnelles pour le style
 * @returns {JSX.Element} Carte de catégorie avec statistiques
 */
export const BoutonQuest = ({ index, libelleRep, status }) => {
    const indexConfig = {
        1: {
            index: 'A',
        },
        2: {
            index: 'B',
        },
        3: {
            index: 'C',
        },
        4: {
            index: 'D'
        }
    };

    const config = indexConfig[index]

    return (
        <div className={`bouton-quest`} data-status={status}>
            <div className="rec-cat">
                <p className="rec-cat-p">{config.index}</p>
            </div>

            <div className="text-cat">
                    <p className="text-cat-p">{libelleRep}</p>
            </div>
        </div>
    );
};
